import { FiltroDTO } from "./filtro.dto";

export class ResultadoFiltrosDTO{
    clientesTransporte : FiltroDTO[];
    empresasTransporte: FiltroDTO[];
    canales: FiltroDTO[];
    subCanales: FiltroDTO[];
    zonasTransporte: FiltroDTO[];
    categorias: FiltroDTO[];
    tiposTareas: FiltroDTO[];
    estadosViaje: FiltroDTO[];
    clientesFinales: FiltroDTO[];
    supervisores: FiltroDTO[];
    marcas: FiltroDTO[];
    productos: FiltroDTO[];
    operaciones: FiltroDTO[];
}